import React from 'react'
import PropTypes from 'prop-types'

import MainDetailNav from './MainDetailNav/MainDetailNav'

import mainDetailContainer from './mainDetailContainer'
import './MainDetail.css'

export const MainDetail = (props) => {
  const {
    currentView,
    detailComponent,
    isSmallScreen,
    mainComponent,
    onNavBackClick,
  } = props

  const showDetail =
    !isSmallScreen || (isSmallScreen && currentView === 'detail')
  const showMain = !isSmallScreen || (isSmallScreen && currentView === 'main')
  const showNav = isSmallScreen && currentView === 'detail'

  return (
    <div className="container MainDetail">
      {showNav && <MainDetailNav onBackClick={onNavBackClick} />}
      <div className="row">
        {showMain && React.createElement(mainComponent)}
        {showDetail && React.createElement(detailComponent)}
      </div>
    </div>
  )
}

MainDetail.propTypes = {
  mainComponent: PropTypes.any,
  detailComponent: PropTypes.any,
  isSmallScreen: PropTypes.bool,
  currentView: PropTypes.oneOf(['main', 'detail']),
}

MainDetail.defaultProps = {
  currentView: 'detail',
}

export default mainDetailContainer(MainDetail)



// WEBPACK FOOTER //
// ./src/components/MainDetail/MainDetail.js